import(/* webpackMode: "eager" */ "/var/www/turivana/frontend/src/app/[locale]/pagar-envio/page.tsx");
